// Mini-cart personalised thumbnail preview.
// This must remain global: Shopify replaces the drawer section with
// innerHTML after cart changes, so scripts embedded in mini-cart.liquid do
// not execute again.
(function () {
  if (window._miniCartPreviewBound) return;
  window._miniCartPreviewBound = true;

  // ── Zoom inside an open preview ──────────────────────────────────────────
  // The preview is a clone of the row's thumbnail, so it came with the row's
  // "Click to preview" tooltip and zoom-in cursor, but nothing listened for a
  // click in there: it promised a zoom it never did (Axel, 29 Sep 2026).
  // Shared by this drawer overlay and the cart page's #cart-preview-modal.
  //
  // Click zooms in on the point clicked; the mouse then pans by moving, a
  // finger by dragging. Click again to zoom back out. `target` is scaled with
  // a transform and `viewport` (its parent) clips it, so it never spills out
  // of the dialog. Returns { reset } so a reused <img> can be put back.
  window.skylitPreviewZoom = function (target, viewport) {
    if (!target || !viewport) return { reset: function () {} };
    if (target._skylitZoom) return target._skylitZoom;

    var zoomed = false;
    var scale = 2.5;
    var ox = 50, oy = 50; // transform-origin, % of the target
    var down = null;      // pointer at pointerdown, to tell a drag from a click
    var dragged = false;

    viewport.style.overflow = 'hidden';
    target.style.transition = 'transform 0.25s ease';
    target.style.cursor = 'zoom-in';
    // A cloned row thumbnail carries the row's own affordances: its tooltip
    // and the hover lift that img[data-preview-click] gets in component-cart.css.
    var prints = target.tagName === 'IMG' ? [target] : target.querySelectorAll('img');
    Array.prototype.forEach.call(prints, function (im) {
      im.removeAttribute('data-preview-click');
      im.removeAttribute('title');
    });
    target.title = 'Click to zoom';

    // Enough to show the print at its own pixel size, so zooming reveals real
    // detail rather than a blurred blow-up, within limits that keep it usable.
    function pickScale() {
      var print = target.tagName === 'IMG' ? target : target.querySelector('.skylit-scene__print') || target.querySelector('img');
      var shown = print ? print.getBoundingClientRect().width : 0;
      if (!print || !print.naturalWidth || !shown) return 2.5;
      return Math.min(4, Math.max(2, print.naturalWidth / shown));
    }

    function apply() {
      target.style.transformOrigin = ox + '% ' + oy + '%';
      target.style.transform = zoomed ? 'scale(' + scale + ')' : '';
    }

    function originAt(clientX, clientY) {
      var r = viewport.getBoundingClientRect();
      if (!r.width || !r.height) return;
      ox = Math.min(100, Math.max(0, (clientX - r.left) / r.width * 100));
      oy = Math.min(100, Math.max(0, (clientY - r.top) / r.height * 100));
    }

    function setZoom(on, clientX, clientY) {
      if (on) {
        scale = pickScale();
        originAt(clientX, clientY);
      }
      zoomed = on;
      target.style.cursor = on ? 'zoom-out' : 'zoom-in';
      target.title = on ? 'Click to zoom out' : 'Click to zoom';
      target.style.touchAction = on ? 'none' : '';
      apply();
    }

    target.addEventListener('pointerdown', function (e) {
      down = { x: e.clientX, y: e.clientY, ox: ox, oy: oy };
      dragged = false;
      if (zoomed && e.pointerType !== 'mouse') {
        try { target.setPointerCapture(e.pointerId); } catch (err) {}
      }
    });

    target.addEventListener('pointermove', function (e) {
      if (!zoomed) return;
      if (e.pointerType === 'mouse') {
        // The mouse pans just by moving: the point under it stays in view.
        target.style.transition = 'none';
        originAt(e.clientX, e.clientY);
        apply();
        return;
      }
      if (!down) return;
      var dx = e.clientX - down.x, dy = e.clientY - down.y;
      if (Math.abs(dx) + Math.abs(dy) > 6) dragged = true;
      // A screen point is origin + scale*(x - origin), so moving the content
      // with the finger by d means moving the origin by -d/(scale-1).
      var r = viewport.getBoundingClientRect();
      target.style.transition = 'none';
      ox = Math.min(100, Math.max(0, down.ox - dx / (scale - 1) / r.width * 100));
      oy = Math.min(100, Math.max(0, down.oy - dy / (scale - 1) / r.height * 100));
      apply();
    });

    function endDrag() { down = null; }
    target.addEventListener('pointerup', endDrag);
    target.addEventListener('pointercancel', endDrag);

    target.addEventListener('click', function (e) {
      // Handled here, not by the overlay underneath: the drawer's overlay
      // closes on any click, and a zoom click must leave it open.
      e.stopPropagation();
      e.preventDefault();
      if (dragged) { dragged = false; return; }
      target.style.transition = 'transform 0.25s ease';
      setZoom(!zoomed, e.clientX, e.clientY);
    });

    target._skylitZoom = {
      reset: function () {
        zoomed = false;
        ox = oy = 50;
        target.style.transition = 'none';
        target.style.cursor = 'zoom-in';
        target.style.touchAction = '';
        target.title = 'Click to zoom';
        apply();
      }
    };
    return target._skylitZoom;
  };

  // The CF Browser Rendering thumbnail can take a few seconds after add to
  // cart. Keep retrying its backend URL while showing the product fallback.
  window._mcPollThumb = window._mcPollThumb || function (img) {
    var backend = img.dataset.backendThumbnail;
    var fallback = img.dataset.fallbackSrc;
    if (fallback && img.src !== fallback) img.src = fallback;
    if (!backend) return;

    var tries = 0;
    (function poll() {
      if (++tries > 20 || !document.contains(img)) return;
      var probe = new Image();
      var bust = backend + (backend.indexOf('?') > -1 ? '&' : '?') + 'v=' + Date.now();
      probe.onload = function () { img.src = bust; };
      probe.onerror = function () { setTimeout(poll, 4000); };
      probe.src = bust;
    })();
  };

  // ── The overlay ──────────────────────────────────────────────────────────
  // Owned here and mounted on <body>, NOT the #mini-cart-lightbox that ships
  // inside sections/mini-cart.liquid. Two reasons:
  //
  //  1. <mini-cart class="cart-drawer"> carries a transform for its slide-in,
  //     and a transformed ancestor becomes the containing block for
  //     position:fixed descendants. The section's overlay therefore covered the
  //     450px drawer instead of the viewport, and its 90vw image overflowed
  //     out of it. Anything on <body> is measured against the viewport.
  //  2. Section Rendering replaces the drawer's markup after every cart change.
  //     An overlay that lives in there is destroyed mid-preview; this one is
  //     built once and outlives every swap, like the rest of this controller.
  var overlay = null;
  var overlayImg = null;
  var overlayScene = null;
  var overlayImgWrap = null;

  function ensureOverlay() {
    if (overlay && document.body.contains(overlay)) return overlay;
    overlay = document.createElement('div');
    overlay.id = 'mini-cart-preview-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Preview');
    overlay.style.cssText = [
      'display:none', 'position:fixed', 'inset:0', 'z-index:100001',
      'background:rgba(0,0,0,0.8)', 'align-items:center', 'justify-content:center',
      'cursor:zoom-out', 'padding:4vmin', 'box-sizing:border-box'
    ].join(';');

    overlayScene = document.createElement('div');
    overlayScene.setAttribute('data-mini-cart-scene-holder', '');
    overlayScene.style.cssText = 'display:none;width:min(90vw,720px);max-width:100%;';

    overlayImg = document.createElement('img');
    overlayImg.alt = 'Preview';
    overlayImg.style.cssText = 'display:none;max-width:90vw;max-height:85vh;object-fit:contain;border-radius:8px;box-shadow:0 8px 32px rgba(0,0,0,0.4);user-select:none;';
    overlayImg.oncontextmenu = function () { return false; };
    overlayImg.ondragstart = function () { return false; };

    // The flat image zooms inside this clip, so it cannot spill past its box.
    overlayImgWrap = document.createElement('div');
    overlayImgWrap.style.cssText = 'display:none;line-height:0;border-radius:8px;overflow:hidden;box-shadow:0 8px 32px rgba(0,0,0,0.4);';
    overlayImg.style.boxShadow = 'none';
    overlayImg.style.borderRadius = '0';
    overlayImgWrap.appendChild(overlayImg);

    overlay.appendChild(overlayScene);
    overlay.appendChild(overlayImgWrap);
    document.body.appendChild(overlay);
    // The overlay is mounted on <body>, outside <mini-cart>, so a click on it
    // reads as an "outside" click to the drawer and closed the drawer as well
    // (Axel, 28 Sep 2026). Swallow it here: closing the preview must leave the
    // drawer exactly as it was.
    overlay.addEventListener('click', function (event) {
      event.stopPropagation();
      event.preventDefault();
      closePreview();
    });
    return overlay;
  }

  function closePreview() {
    if (!overlay) return;
    overlay.style.display = 'none';
    overlayImg.style.display = 'none';
    overlayImgWrap.style.display = 'none';
    overlayImg.removeAttribute('src');
    if (overlayImg._skylitZoom) overlayImg._skylitZoom.reset();
    // Drop the clone rather than leave it polling for a print behind a hidden
    // overlay; the scene controller stops on its own once it is disconnected.
    overlayScene.innerHTML = '';
    overlayScene.style.display = 'none';
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mini-cart-preview]');
    if (!trigger) return;

    var scene = trigger.querySelector('.skylit-scene');

    // A framed line previews as the SCENE, not a flat picture: the frame the
    // customer just bought from this drawer is a border-image on the mount, so
    // lifting the <img> out of it would show the print with no frame — the one
    // thing the preview is being opened to check.
    if (scene) {
      event.preventDefault();
      ensureOverlay();
      var clone = scene.cloneNode(true);
      clone.removeAttribute('style');
      // The row's loader is positioned against the row's box; drop it and let
      // the clone raise its own, sized to this overlay.
      Array.prototype.forEach.call(clone.querySelectorAll('.cart-thumb-generating'), function (n) {
        n.parentNode.removeChild(n);
      });
      // A clone of an initialised scene carries its flags and would sit there
      // inert — no polling, no loader, and a broken <img> while the render is
      // still in flight. Clear them and hand it to the same controller the rows
      // use, so a preview opened during the wait fills itself in rather than
      // needing to be closed and reopened. 'mount' puts the spinner in the
      // artwork instead of over the whole room, which is the only place it can
      // go without covering the frame.
      clone.removeAttribute('data-scene-init');
      clone.removeAttribute('data-scene-polling');
      clone.setAttribute('data-loader-target', 'mount');
      overlayScene.innerHTML = '';
      overlayScene.appendChild(clone);
      overlayScene.style.display = 'block';
      overlayImg.style.display = 'none';
      overlayImgWrap.style.display = 'none';
      overlay.style.display = 'flex';
      try { if (window._skylitSceneInit) window._skylitSceneInit(); } catch (e) {}
      window.skylitPreviewZoom(clone, overlayScene);
      return;
    }

    var img = trigger.querySelector('img');
    if (!img || !img.src) return;

    event.preventDefault();
    ensureOverlay();
    overlayScene.innerHTML = '';
    overlayScene.style.display = 'none';
    overlayImg.src = img.src;
    overlayImg.style.display = 'block';
    overlayImgWrap.style.display = 'block';
    overlay.style.display = 'flex';
    window.skylitPreviewZoom(overlayImg, overlayImgWrap);
  });

  // Escape closes only the preview while it is open; run in the capture
  // phase and stop the event so the drawer's own Escape handler does not
  // close the drawer underneath at the same time.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!overlay || overlay.style.display !== 'flex') return;
    event.stopImmediatePropagation();
    event.preventDefault();
    closePreview();
  }, true);
})();
